import { ITagStatus } from '@tecalisdev/infinity';

export interface IViewMediaActivity {
	type: string;
	text: string;
	link?: string | null;
	companyUuid?: string | null;
}

export interface IViewMedia {
	show: boolean;
	title: string;
	tag: { label: string; status: ITagStatus };
	subtitle: string;
	activity?: IViewMediaActivity | null;
	downloadFileName?: string | null;
	developerCurl?: {
		path: string;
		titleKey: string;
	} | null;
	data: IMedia[];
}

/** Alineado con el contrato Infinity `IMedia` (`tec-view-media`). */
export type ViewMediaType = 'image' | 'video' | 'pdf';

export interface IMedia {
	title?: string;
	tag?: {
		label?: string;
		status?: ITagStatus;
	};
	detailLabel?: string;
	type: ViewMediaType;
	doc: string;
	selected: boolean;
	scale: number;
	pdfRenderScale?: number;
}

/**
 * Infere el tipo de media para Infinity a partir de la URL (PDF vs imagen).
 * Sin petición de red: extensión / path conocidos.
 */
export function resolveViewMediaTypeFromUrl(url: string): ViewMediaType {
	const normalized = (url ?? '').trim().toLowerCase();
	if (!normalized) {
		return 'image';
	}
	try {
		const path = new URL(normalized).pathname;
		if (/\.pdf$/i.test(path) || path.includes('/pdf/') || path.includes('%2fpdf%2f')) {
			return 'pdf';
		}
	} catch {
		if (/\.pdf(\?|#|$)/i.test(normalized) || normalized.includes('.pdf')) {
			return 'pdf';
		}
	}
	if (/\.(mp4|webm|ogg|mov)(\?|#|$)/i.test(normalized)) {
		return 'video';
	}
	return 'image';
}

/** Nombre de descarga a partir de la URL o fallback por tipo. */
export function resolveDownloadFileNameFromUrl(
	url: string,
	fallbackBase: string,
	mediaType: ViewMediaType,
): string {
	try {
		const parsed = new URL(url);
		const pathname = parsed.pathname.split('/').filter(Boolean);
		const lastSegment = pathname[pathname.length - 1];
		if (lastSegment) {
			return decodeURIComponent(lastSegment);
		}
	} catch {
		/* URL relativa o inválida */
	}
	const ext = mediaType === 'pdf' ? 'pdf' : mediaType === 'video' ? 'mp4' : 'jpg';
	return `${fallbackBase}.${ext}`;
}
